import { JsonObject, JsonProperty } from 'json2typescript';

import { CountryInterface } from '../../../core';
import { Id } from './id';
import { IdAdapter } from '../../client/helpers/serializer/adapters/id.adapter';
import { StringAdapter } from '../../client/helpers/serializer/adapters/string.adapter';

@JsonObject('Country')
export class Country implements CountryInterface {
    @JsonProperty('Id', IdAdapter, true)
    private _id: Id = undefined;

    @JsonProperty('Name', StringAdapter, true)
    private _name: string = undefined;

    @JsonProperty('Risk', Boolean, true)
    private _risk = false;

    get id(): Id {
        return this._id;
    }

    get name(): string {
        return this._name;
    }

    get risk(): boolean {
        return this._risk;
    }
}
